import HttpService from "./HttpService";

let arquivoService = {
    upload: (arquivo, tabela, id, novoNome) => {
        return HttpService.backApi.post(`/arquivos/upload?tabelaOrigem=${tabela}&cdTabela=${id}&novoNome=${novoNome}`, arquivo);
    },
    lista: (tabela, id) => {
        return HttpService.backApi.get(`/arquivos/lista?tabelaOrigem=${tabela}&cdTabela=${id}`);
    },
    download: (arquivo) => {
        return HttpService.backApi.post(`/arquivos/download`,arquivo);
    },
    downloadListaDeAlunos: (cdTurma) => {
        return HttpService.backApi.get(`/export/turma/${cdTurma}`);
    },
    downloadById: (id) => {
        return HttpService.backApi.get(`/arquivos/download/${id}`);
    },
    delete: (id) => {
        return HttpService.backApi.delete(`/arquivos/delete/${id}`);
    },

    base64ToArrayBuffer(base64) {
        var binaryString = window.atob(base64);
        var binaryLen = binaryString.length;
        var bytes = new Uint8Array(binaryLen);
        for (var i = 0; i < binaryLen; i++) {
            var ascii = binaryString.charCodeAt(i);
            bytes[i] = ascii;
        }
        return bytes;
    },

    showFile(file, contentType) {
        var dataURI = `data:${contentType};base64,` + file;
        var iframe = "<iframe width='100%' height='100%' src='" + dataURI + "'></iframe>"
        var x = window.open();
        x.document.open();
        x.document.write(iframe);
        x.document.close();
    },

    saveByteArray(reportName, byte, type) {
        var blob = new Blob([byte], {type: type});
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        var fileName = reportName;
        link.download = fileName;
        link.click();
    },
};

export default arquivoService;
